import { includes, isArray } from 'lodash'
import { Observable, of } from 'rxjs'

import { IDropdownOtherFieldValue, IDropdownQuestionOtherFieldSettings } from '../../model/question'
import { addOtherOption } from '../../utils'
import { SelectOption } from '../'
import { QuestionBase, QuestionOptions } from './base.question.class'

export interface DropdownCustomQuestionOptions {
  'dropdown-opts'?: SelectOption<string>[]
  selected?: string | string[]
  otherFieldSettings?: IDropdownQuestionOtherFieldSettings
  ui?: string
}

export interface DropdownQuestionInterface extends QuestionOptions<string> {
  options?: SelectOption<string>[] | DropdownCustomQuestionOptions
  selected?: string
}

export class DropdownQuestion extends QuestionBase<string> {
  override controlType = 'dropdown'
  declare options: Observable<SelectOption<string | IDropdownOtherFieldValue>[]>
  multiple = false
  if: string | string[]
  otherFieldSettings?: IDropdownQuestionOtherFieldSettings

  get showIfQuestions() {
    return (
      this.ifQuestions.length > 0 && this.valid && includes(this.if, this.value)
    )
  }

  constructor(options: DropdownQuestionInterface = {}) {
    super(options)
    if (this.isCustom) {
      const otherFieldSettings = (options.options as DropdownCustomQuestionOptions).otherFieldSettings
      this.otherFieldSettings = otherFieldSettings
      const customOptions = addOtherOption(
        options.options['dropdown-opts'] || [],
        otherFieldSettings,
      )

      this.options = of(customOptions)
    } else if (isArray(options.options)) {
      this.options = of(options.options)
    } else {
      this.options = of([])
    }

    if ('dropdown-opts' in options.options) {
      if (isArray(options.options.selected)) {
        this.if = options.options.selected
      }
    }
    this.ifQuestions = options.ifQuestions
  }

  public hasOtherOption() {
    return !!this.isCustom && !!this.otherFieldSettings?.enabled
  }
}
